import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const { url } = JSON.parse(this.data.get("params") || '{}');

    let opts = this.getDefaultParams();
    let data = $(this.element).data();

    if (url) {
      opts.ajax = {
        url,
        delay: 250,
        data: (params) => {
          return {
            q: params.term,
            page: params.page || 1
          };
        },
        processResults: (data, params) => {
          params.page = params.page || 1;

          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        cache: true
      }
    }

    // https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
    if (data.fixParent) {
      opts.dropdownParent = String(data.fixParent) == 'true' ? this.element.parentNode : $(data.fixParent);
    }

    $(this.element).select2(opts);
  }

  getDefaultParams() {
    return {
      width: '100%'
    };
  }

  disconnect() {
    $(this.element).select2('destroy');
  }
}
